import BaseRepository from '@repository/BaseRepository';

class jobRepository extends BaseRepository{
  constructor(baseUrl){
    super(baseUrl);
  }

  getCounter = (url, params) => {
    return this.post(url, params);
  }
}

export default jobRepository;
